/**
 * Speed Dial [FVD] — new-tab page / bookmarks
 *
 * Declares one web-accessible-resource entry matched to every origin with no
 * `use_dynamic_url`, exposing exactly three files: `images/cropper/img.png`,
 * `newtab.html` and `content-scripts/hiddencapture-inject.js`. All are reachable from any
 * page at a fixed URL. The cropper image loads through `probeImage` with no CORS grant,
 * and the vendor-named inject script is a distinctive corroborator.
 *
 * Manifest verified against version 81.8.35.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'llaficoajjainaijghjlofdfmbjpebpa';

export const speedDialFvd: ExtensionDefinition = {
  id: ID,
  name: 'Speed Dial [FVD] - New Tab Page, 3D, Sync...',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'Three static WAR on every origin with no dynamic URL. The cropper image loads ' +
    'without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-cropper-img',
      kind: 'web-accessible-resource',
      description:
        'Load images/cropper/img.png via <img> — a packaged image exposed to every ' +
        'origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/cropper/img.png'),
    },
    {
      id: 'war-hiddencapture-inject-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/hiddencapture-inject.js — a vendor-named injected script, ' +
        'a distinctive second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-scripts/hiddencapture-inject.js'),
    },
    {
      id: 'war-newtab-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch newtab.html — the new-tab entry point, independent of the image and ' +
        'inject script.',
      weight: 0.5,
      run: () => probeFetch(ID, 'newtab.html'),
    },
  ],
};
